// @ts-nocheck



import type RequestsController from '../requests';
import type { WialonApiSection } from '../requests';

export class Messages {
  controller: WialonApiSection;

  constructor(controller: RequestsController) {
    this.controller = controller.getApiSection('messages');
  }

  /**
   * Подгрузка последнего сообщения
   * @param params Параметры запроса
   */
  async loadLast(params)












  {
    return await this.controller.fetch('load_last', params);
  }

  /**
   * Загрузить сообщения за интервал
   */
  async loadInterval(params)












  {
    return await this.controller.fetch('load_interval', {
      flag: 1,
      flagsMask: 65281,
      loadCount: 4294967295,
      ...params
    });
  }

  /**
   * Получить сообщения
   */
  async getMessages(params)












  {
    return await this.controller.fetch('load_interval', params);
  }
}
